define(
  'labelMoreSection',[
    'i18n!nls/res',
    'paramsObserver'
  ],
  (
    res,
    paramsObserver
  ) => {
    'use strict';

    const defaultParams = paramsObserver.getUniqueParameters();

    function getElements(elements) {
      const returnElements = [];
      for (let index = 0; index < elements.length; index += 1) {
        const element = elements[index];
        if (!defaultParams[element.getAttribute('data-param')]) {
          returnElements.push(element);
        }
      }

      return returnElements;
    }

    function showMoreLabel() {
      const morePanelTemplate = document.querySelector('#nhs_FacetMore [data-template-facet]');
      const summaryMore = document.querySelector('[data-summary="more"]');
      const builderTemp = document.querySelector('[data-template-facet-builder-name]');
      const commName = document.querySelector('[data-template-facet-community-name]');
      const divPanel = document.createElement('div');
      divPanel.innerHTML = morePanelTemplate.innerHTML + builderTemp.innerHTML + commName.innerHTML;
      const elements = getElements(divPanel.querySelectorAll(
        'input:not([data-reset-value]):checked, option[selected]:not([data-reset-value])'
      ));

      const firstLi = document.createElement('li');
      const secondLi = document.createElement('li');
      if (elements.length === 0) {
        firstLi.innerHTML = res.all;
      }

      if (elements.length >= 1) {
        firstLi.innerHTML = elements[0].getAttribute('data-label');
      }

      if (elements.length === 2) {
        secondLi.innerHTML = elements[1].getAttribute('data-label');
      }

      if (elements.length > 2) {
        secondLi.innerHTML = (elements.length - 1) + ' ' + res.more;
      }
      summaryMore.appendChild(firstLi);
      summaryMore.appendChild(secondLi);
    }

    showMoreLabel();
  }
);

